<template>
    <div class="inline-flex items-center">
        <span @click="$emit('go-back')">
            <i class="fas text-xs fa-arrow-left mr-3 cursor-pointer" />
        </span>
        <h4>{{ title }}</h4>
    </div>
</template>

<script>
export default {
    name: 'TitleSection',
    props: {
        title: { type: String, required: true }
    }
}
</script>
